import { useEffect } from 'react'
import { FormikState, FormikValues } from 'formik'

const useAutoSelectCountryByPhone = (
    setFormikState: (
        f:
            | FormikState<FormikValues>
            | ((prevState: FormikState<FormikValues>) => FormikState<FormikValues>),
        cb?: () => void,
    ) => void,
    fiscalLocation,
    phoneData,
) => {
    useEffect(() => {
        if (!phoneData) return

        const { countryCode: phoneCountryCode } = phoneData

        if (!fiscalLocation.country?.isoCode && phoneCountryCode) {
            setFormikState((prevState: FormikState<any>) => ({
                ...prevState,
                values: {
                    ...prevState.values,
                    fiscalLocation: {
                        country: {
                            isoCode: phoneCountryCode?.toUpperCase(),
                        },
                    },
                },
            }))
        }
    }, [phoneData?.countryCode])
}

export { useAutoSelectCountryByPhone }
